import UploadIcon from '@mui/icons-material/Upload';
import { Button } from '@mui/material';
import { Uppy } from '@uppy/core';
import ImageEditor from '@uppy/image-editor';
import EnglishLocale from '@uppy/locales/lib/en_US';
import { DashboardModal, useUppy } from '@uppy/react/lib';
import ScreenCapture from '@uppy/screen-capture';
import Webcam from '@uppy/webcam';
import XHRUpload from '@uppy/xhr-upload';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import FrenchLocale from 'FRONTEND/components/FileUploadField/fr_FR';
import i18n from 'FRONTEND/utils/i18n';
import { PJAX_MAIN_CONTAINER_SELECTOR } from 'LEGACY/constants';

import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import '@uppy/image-editor/dist/style.css';
import '@uppy/screen-capture/dist/style.css';
import '@uppy/webcam/dist/style.css';

const UploadDialog = ({
  href,
  label,
}) => {
  /**
   * Upload dialog for patient documents page.
   */
  const [uploadDialogOpened, setUploadDialogOpened] = useState(false);
  const locale = useSelector((state) => state.user.locale);

  const uppyLocale = locale === 'fr' ? FrenchLocale : EnglishLocale;

  const uppy = useUppy(() => {
    // Uppy instance.
    return new Uppy({
      restrictions: {
        maxNumberOfFiles: 10,
      },
      locale: uppyLocale,
    })
      .use(ImageEditor, { locale: uppyLocale })
      .use(ScreenCapture, { locale: uppyLocale, preferredVideoMimeType: 'video/webm' })
      .use(Webcam, {
        locale: uppyLocale,
        preferredImageMimeType: 'image/png',
        preferredVideoMimeType: 'video/webm',
        showVideoSourceDropdown: true,
      })
      .use(XHRUpload, {
        endpoint: href,
        headers: {
          Accept: 'application/json',
          'X-CSRF-Token': window.CSRFToken,
        },
      })
      .on('complete', (result) => {
        if (result.successful.length) {
          setUploadDialogOpened(false);
          $.pjax.reload(PJAX_MAIN_CONTAINER_SELECTOR);
          uppy.cancelAll();
        }
      });
  });

  return (
    <>
      <DashboardModal
        trigger='.uploadDialog-button'
        target={document.getElementsByTagName('body')[0]}
        uppy={uppy}
        open={uploadDialogOpened}
        closeAfterFinish
        closeModalOnClickOutside
        onRequestClose={() => {
          setUploadDialogOpened(false);
        }}
        plugins={['ImageEditor', 'ScreenCapture', 'Webcam']}
        proudlyDisplayPoweredByUppy={false}
        locale={uppyLocale}
        metaFields={[
          { id: 'name', name: i18n._('Name') },
          { id: 'description', name: i18n._('Description') },
        ]}
        showLinkToFileUploadResult={false}
        showProgressDetails
      />
      <Button
        variant='contained'
        onClick={() => {
          setUploadDialogOpened(true);
        }}
        className='uploadDialog-button'
        startIcon={<UploadIcon />}
      >
        {label}
      </Button>
    </>
  );
};

export default UploadDialog;
